export default "__VITE_ASSET__DAET8gYB__"